var map = {
	"./en_US.js": "0c9a",
	"./getShortCodes.js": "68a0",
	"./index.js": "3cdc",
	"./ru_RU.js": "d634"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d583";
module.exports = webpackAsyncContext;